import Environment from './environment';

/**
 * ヘッダー関連の処理
 */
export default class Header {
  constructor() {
    this.setHeaderFixed();
    this.spNav();
    this.navAccordion();
    this.eventHandler();
  };

  /**
   * ヘッダー固定処理
   */
  setHeaderFixed() {
    let $headerEl;
    if ($('.l-header-compact').length > 0) {
      $headerEl = $('.l-header-compact');
    } else {
      $headerEl = $('.l-header');
    }
    let $scrollVal = $(window).scrollTop();
    if (0 < $scrollVal) {
      $headerEl.addClass('is-fixed');
    } else {
      $headerEl.removeClass('is-fixed');
    }
  };

  /**
   * スマホ ナビゲーション
   */
  spNav() {
    $('#js-header-nav').on('click', function () {
      if ($('header.l-header').hasClass('is-open')) {
        $('header.l-header').removeClass('is-open');
      } else {
        $('header.l-header').addClass('is-open');
      }
    });
    $('.l-header__bg').on('click', function () {
      $('header.l-header').removeClass('is-open');
    });
  };

  /**
   * スマホ ナビゲーション アコーディオン
   */
  navAccordion() {
    $('.l-header__nav-item .js-accordion').on('click', function (e) {
      let deviceType = Environment.getDeviceType();
      if (deviceType == 'sp') {
        e.preventDefault();
        if ($(this).parent().hasClass('is-open')) {
          $(this).parent().removeClass('is-open');
          $(this).next().slideUp();
        } else {
          $('.l-header__nav-item').removeClass('is-open');
          $('.l-header__nav-childlist').slideUp();
          $(this).parent().addClass('is-open');
          $(this).next().slideDown();
        }
      }
    });
  };

  /**
   * SP→PCに切り替えた際にアコーディオンが適用されてしまうのでstyle属性を削除
   */
  resetNavAccordion() {
    let deviceType = Environment.getDeviceType();
    if (deviceType == 'pc') {
      $('.l-header__nav-item').removeClass('is-open');
      $('.l-header__nav-childlist').removeAttr('style');
    }
  };

  /**
   * イベントハンドラー
   */
  eventHandler() {
    window.addEventListener('scroll', this.setHeaderFixed);
    window.addEventListener('resize', this.resetNavAccordion);
  };
}
